import { withAuth } from '@/utilities/queries';
import { getAuthTokenInfo } from '@simplywallst/services';
import { useQuery } from '@tanstack/react-query';
import useUser from '../useUser';

export const queryKey = ['AUTH_TOKEN_INFO'] as const;
/**
 *
 * Hook for getting auth token info.
 *
 */
export function useAuthInfo() {
  const { data } = useUser();
  const authTokenInfoQuery = useQuery({
    queryKey,
    queryFn: async () => {
      const response = await withAuth(getAuthTokenInfo);
      return response.data;
    },
    enabled: data.loggedIn,
  });
  return authTokenInfoQuery;
}
